import { FC, useEffect, useState } from "react";

// * Components
import ChatWidget from "../../components/ChatWidget";

// * Types
import { IMessage } from "../../components/ChatWidget/WidgetMessage/WidgetMessage.interface";

// * Mock
import { messages } from "../../components/ChatWidget/ChatWidget.data";

// * Helpers
import { getRouteParams } from "../../helpers/getRouteParams";

// * Plugins
import { cable } from "../../plugins/cable";

// * Hooks
import { useGetChatMessagesQuery } from "../../features/api/apiSlice";

// * Styles
import styles from "./Widget.module.css";

const Widget: FC = () => {

  // * Messages state
  const [messagesArray, setMessages] = useState(messages);

  // * Widget params from url
  const widgetParams = getRouteParams(window.location.href);

  // * Get messages from chat
  const { isSuccess, data: fetchedMessages } = useGetChatMessagesQuery({
    id: widgetParams.id,
    token: widgetParams.chat_token
  });

  useEffect(() => {
    if (isSuccess) {
      const reversedMessages = [...fetchedMessages.response].reverse();
      setMessages([...messagesArray, ...reversedMessages]);
    }
  }, [fetchedMessages]);

  // * Connect to chat
  const consumer = cable(widgetParams.chat_token);

  useEffect(() => {
    consumer.subscriptions.create(
      {
        channel: "ChatChannel",
        room: `Room_${widgetParams.id}`,
        broadcast_id: widgetParams.id,
      },
      {
        received(data: IMessage) {
          setMessages((state) => {
              return [...state, data];
          });
        },
      }
    );
  }, []);

  // * Hide page background
  useEffect(() => {
    const root = document.querySelector("#root") as HTMLElement;
    root.style.background = "transparent";
  }, []);

  return (
    <div className={styles.widget}>
      <ChatWidget
        messages={messagesArray}
        scale={widgetParams.scale}
        nameColor={`#${widgetParams.name_color}`}
        messageColor={`#${widgetParams.message_color}`}
        backgroundColor={`#${widgetParams.background_color}`}
      />
    </div>
  );
};

export default Widget;
